import { Component, Input } from '@angular/core'
import { MbConstants } from '../../../../shared/mb-constants'
import { UntypedFormGroup } from '@angular/forms'
import { Address } from '@spartacus/core'

@Component({
  selector: 'mb-checkout-base-form-partial',
  templateUrl: './mb-checkout-base-form-partial.component.html',
  styleUrls: ['./mb-checkout-base-form-partial.component.scss'],
})
export class MbCheckoutBaseFormPartialComponent {

  constants = MbConstants

  @Input() address: Address = {}
  @Input() formGroup: UntypedFormGroup | undefined
  @Input() companyLabelKey = 'address.companyUniversity'
  @Input() instituteLabelKey = 'address.institute'
  @Input() departmentLabelKey = 'address.departmentDivision'
  @Input() buildingLabelKey = 'address.buildingFloorRoom'
  @Input() labLabelKey = 'address.labGroupPI'
  @Input() displayShippingLabel = false
}
